import type { SVGProps } from 'react';
const SvgTransferWithinAStation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#transfer_within_a_station_svg__a)">
      <path
        fill="currentColor"
        d="M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5h-5.51Zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18v1.75ZM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2ZM5.75 8.9 3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75Z"
      />
    </g>
    <defs>
      <clipPath id="transfer_within_a_station_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTransferWithinAStation;
